module.exports = __webpack_public_path__ + "images/valentin-7ed3691081f19ebcafa01047cad5f316.jpg";